export const resolveMediaSrc = (src) => {
  if (!src) return '';
  if (typeof src === 'string') return src;
  if (typeof src === 'object' && src.default) return src.default;
  return String(src);
};

export const isVideoMedia = (src) => {
  const resolved = resolveMediaSrc(src);
  if (!resolved) return false;

  const normalized = resolved.split('?')[0].split('#')[0].toLowerCase();
  return ['.mp4', '.webm', '.mov', '.m4v'].some((ext) => normalized.endsWith(ext));
};
